import React from 'react';
import { useStyles } from './SessionTree.styles';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutline';
import { WorkMode, SessionTreeProps } from './SessionTree.types';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { Chip } from '@mui/material';

const SessionTree: React.FC<SessionTreeProps> = (props) => {
  const classes = useStyles();

  return (
    <>
      <div
        className={props.activeTreeLevel === props.level ? classes.sessionTreeActiveItem : ''}
        style={{ fontWeight: 700 }}
        onClick={() => {
          if (props.workMode === WorkMode.ADD) return;
          props.setActiveTreeLevel(props.level);
          props.setActiveTreeId(props.data.id);
        }}
      >
        <div className={classes.sessionTreeItem}>
          {props.isSessionNameExpanded ? (
            <TooltipOne title="Zwiń element" placement="left">
              <IndeterminateCheckBoxOutlinedIcon
                className={classes.ArrowDropDownIcon}
                style={{ top: '4px', height: '0.6em' }}
                onClick={() => {
                  props.setIsSessionNameExpanded(!props.isSessionNameExpanded);
                }}
              />
            </TooltipOne>
          ) : (
            <TooltipOne title="Rozwiń element" placement="left">
              <AddBoxRoundedIcon
                className={classes.ArrowDropDownIcon}
                style={{ top: '4px', height: '0.6em' }}
                onClick={() => {
                  props.setIsSessionNameExpanded(!props.isSessionNameExpanded);
                }}
              />
            </TooltipOne>
          )}
          <p className={classes.sessionTreeTextItem}>
            <TooltipOne title={props.data.name} placement="right">
              <span>{props.data.name}</span>
            </TooltipOne>
          </p>
          {props.isTrainingSession && <Chip label="Sesja treningowa" variant="outlined" color="success" />}
          {!props.isReadOnly() &&
            props.activeTreeLevel === props.level &&
            (props.editedItemId !== props.data.id ? (
              <TooltipOne title="Edytuj" placement="top">
                <EditIcon
                  className={classes.sessionTreeEditIcon}
                  onClick={() => {
                    props.setActiveTreeLevel(props.level);
                    props.setEditedItemId(props.data.id);
                    props.setWorkMode(WorkMode.EDIT);
                  }}
                />
              </TooltipOne>
            ) : (
              <TooltipOne title="Usuń" placement="top">
                <DeleteOutlineOutlinedIcon className={classes.sessionTreeEditIcon} onClick={props.removeTreeItem} />
              </TooltipOne>
            ))}
        </div>
      </div>
    </>
  );
};

export default SessionTree;
